import React, { Component } from 'react'
import { connect } from "react-redux";
import AddressList from './addresses/Addresses'
import User from './user/User'
import Submenu from './Submenu'
import {removeAddress, updateAddress, favAddress} from '../../actions/index'


class Settings extends Component{
    constructor(props) {
        super(props);
        this.state = {
            showNewAddress: false,
            activeSection: 'userdata'
        }
    }
    toggle() {
        this.setState({
            showNewAddress: !this.state.showNewAddress
        })
    }
    changeSection(e){
        this.setState({ activeSection: e.target.id})
    }
    render(){
        return(
            <div className="justify-content-md-center">
                <div className="col-md-12 content-container">
                    <h1 className="text-secondary mb-4">Ajustes de usuario</h1>
                    <Submenu
                        changeSection={this.changeSection.bind(this)}
                        activeSection={this.state.activeSection}
                    />
                    <div className="settings-content">
                            {{
                                'userdata': (
                                    <User
                                        user={this.props.user}
                                    />
                                ),
                                'addresses': (
                                    <AddressList
                                        user={this.props.user}
                                        actionDelete={this.props.removeAddress}
                                        actionUpdate={this.props.updateAddress}
                                        actionFav={this.props.favAddress}
                                    />
                                ),
                            }[this.state.activeSection]}
                    </div>
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        user: state.user,
    };
}
export default connect(mapStateToProps, {removeAddress, updateAddress, favAddress})(Settings);


// WEBPACK FOOTER //
// ./resources/assets/js/components/settings/Settings.jsx